import { authApiService } from '@/api/authApiService';
import { ApiResponseType } from '@/types/sharedTypes';

export type CreateSinglePaymentCheckoutSessionPayloadType = {
  ui_mode: 'custom' | 'embedded' | 'hosted';
  return_url: string;
  quantity: number;
};

export type CreateSinglePaymentCheckoutSessionResponseType = {
  client_secret: string;
  final_amount: string;
};

export const createSinglePaymentCheckoutSessionApi = (
  data: CreateSinglePaymentCheckoutSessionPayloadType
): Promise<ApiResponseType<CreateSinglePaymentCheckoutSessionResponseType>> => {
  const uri = '/billing/checkout_session/payment/';

  return authApiService.POST(uri, data);
};
